module.exports = __webpack_public_path__ + "img/banner.6bee565c.png";